import styles from "./checkbox.module.scss"

const Checkbox = (props: { id: string; checked: boolean; onChange: (event) => void }) => {
  return (
    <input
      className={styles.checkbox}
      id={props.id}
      checked={props.checked}
      type={"checkbox"}
      data-value={props.id}
      onChange={props.onChange}
    />
  )
}

export default Checkbox
